import HelixIcon, { HelixIconType } from '@components/icon/icon';
import { Error as ErrorIcon } from '@mui/icons-material';
import { FormHelperText, Stack, TextFieldProps, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

type HelixHelperTextProps = {
  helperText?: string;
  error?: boolean;
  color?: TextFieldProps['color'];
  variant: TextFieldProps['variant'];
  disabled?: boolean;
  value?: string;
  maxLength?: number;
};

const HelixHelperText: React.FC<HelixHelperTextProps> = ({
  helperText,
  error = false,
  color,
  variant,
  disabled,
  value,
  maxLength,
}) => {
  const [charCount, setCharCount] = useState<number>(value?.length ?? 0);
  useEffect(() => setCharCount(value?.length ?? 0), [value]);

  const hasMaxLength = !!maxLength && maxLength > 0;
  const normalizedColor = error ? 'error' : color;
  let helperTextContent;

  if (helperText === ' ' && !hasMaxLength) {
    // Allowing for the default MUI FormHelperText to take over. This includes the special case for " ".
    helperTextContent = ' ';
  } else if (hasMaxLength || !!helperText) {
    const hasIcon = normalizedColor === 'error';
    // To properly layout the HelixIcon and text we use a Stack. We must also surround the text with a span
    // otherwise it's an anonymous text element and Stack doesn't handle it.
    helperTextContent = (
      <Stack direction="row" spacing={0.5}>
        {hasIcon && (
          <HelixIcon sx={{ marginTop: '-1px' }} type={HelixIconType.MUI} rem={1} color={normalizedColor}>
            <ErrorIcon />
          </HelixIcon>
        )}
        <Typography variant="helper" color={normalizedColor ?? 'black'}>
          {helperText}
        </Typography>
        {hasMaxLength && (
          <div style={{ marginLeft: 'auto' }}>
            <Typography variant="helper">
              {charCount}/{maxLength}
            </Typography>
          </div>
        )}
      </Stack>
    );
  }

  return (
    <FormHelperText variant={variant} disabled={disabled} component="div">
      {helperTextContent}
    </FormHelperText>
  );
};

export { HelixHelperText as default, HelixHelperText };
export type { HelixHelperTextProps };
